var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5V3.5H2V5H14ZM14 8H2V12.5H14V8ZM0.5 3.5C0.5 2.675 1.175 2 2 2H14C14.3978 2 14.7794 2.15804 15.0607 2.43934C15.342 2.72064 15.5 3.10218 15.5 3.5V12.5C15.5 12.8978 15.342 13.2794 15.0607 13.5607C14.7794 13.842 14.3978 14 14 14H2C1.60218 14 1.22064 13.842 0.93934 13.5607C0.658035 13.2794 0.5 12.8978 0.5 12.5V3.5ZM3.5 9.5H6.5V11H3.5V9.5Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.c271fff89a810a68e586cf8607f9ec4a.svg";
export { ForwardRef as ReactComponent };